import { Component, Input } from '@angular/core';
import { CONFLICTS_DIALOG } from 'src/testIds';
import { AvailabiltyStats } from '../../bookings/shared/availability-response.model';
import { TestIdDirective } from '../directives/test-id.directive';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-item-availability-stats',
    templateUrl: './item-availability-stats.component.html',
    standalone: true,
    imports: [NgIf, TestIdDirective]
})
export class ItemAvailabilityStatsComponent {
  testIds = CONFLICTS_DIALOG;

  @Input() item: AvailabiltyStats;
  @Input() product: AvailabiltyStats;
  @Input() category: AvailabiltyStats;
}
